import { assign } from 'xstate5';

import { type ReorderEventParams, type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storeResponse: ReorderMachineAction<ReorderEventParams> = assign(
  ({ context }, params) => ({
    response: params.reorderEvent.response ?? context.response,
  }),
);
